import { createFileRoute, notFound } from '@tanstack/react-router';

interface IKitSearch {
  flow?: string;
  node?: string;
}

const text = (value: unknown): string | undefined =>
  typeof value === 'string' && value !== '' ? value : undefined;

// Dev only, deliberately absent from widgets/app-shell's nav; a production build 404s here
// rather than shipping xyflow and the flow contracts to every visitor.
export const Route = createFileRoute('/_shell/dev/flow-kit')({
  validateSearch: (search: Record<string, unknown>): IKitSearch => ({
    flow: text(search.flow),
    node: text(search.node),
  }),
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw notFound();
  },
});
